import { render, staticRenderFns } from "./DentalDictamen.vue?vue&type=template&id=217fae7c&scoped=true"
import script from "./DentalDictamen.vue?vue&type=script&lang=js"
export * from "./DentalDictamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217fae7c",
  null
  
)

export default component.exports